<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="12" class="fill-brand" />
    <path fill-rule="evenodd" clip-rule="evenodd"
        d="M16.4333 11.2C16.9667 11.6 16.9667 12.4 16.4333 12.8L11.1 16.8C10.4408 17.2944 9.5 16.824 9.5 16V8C9.5 7.17595 10.4408 6.70557 11.1 7.2L16.4333 11.2Z"
        fill="white" />
</svg>